// Footer columns: always open on desktop, collapsible accordions on mobile.
if (!customElements.get('footer-accordion')) {
  customElements.define(
    'footer-accordion',
    class FooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.sync = this.sync.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
      }

      connectedCallback() {
        this.sync();
        this.mediaQuery.addEventListener('change', this.sync);
        this.addEventListener('click', this.onSummaryClick);
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.onSummaryClick);
      }

      sync() {
        this.querySelectorAll('.footer-block__details').forEach((details) => {
          // Keep a column open on mobile when it shows a form message (newsletter success or error).
          details.open = this.mediaQuery.matches || Boolean(details.querySelector('.form__message'));
        });
      }

      onSummaryClick(event) {
        if (this.mediaQuery.matches && event.target.closest('.footer-block__details > summary')) {
          event.preventDefault();
        }
      }
    }
  );
}
